module.exports = __webpack_public_path__ + "static/media/packageDefault.5190a3a5.jpg";